module.exports = __webpack_public_path__ + "static/discussion-723ba4741aca5c0b84e0d6fabd34f62f.png";